import { Euler, Vector3 } from 'three'

interface IPositionAndScale {
  [key: string]: {
    position: Vector3
    scale: number
    rotation: Euler
  }
}

export const initialPositionAndScale: IPositionAndScale = {
  tabletHorizontal: {
    position: new Vector3(0, 0, 0),
    scale: 1,
    rotation: new Euler(0, 0, 0),
  },
  tabletVertical: {
    position: new Vector3(0, 0, 0),
    scale: 1,
    rotation: new Euler(0, 0, 0),
  },
  mobileHorizontal: {
    position: new Vector3(0, 0, 0),
    scale: 1,
    rotation: new Euler(0, 0, 0),
  },
  mobileVertical: {
    position: new Vector3(0, 0, 0),
    scale: 1,
    rotation: new Euler(0, 0, 0),
  },
  laptop: {
    position: new Vector3(0, 0, 0),
    scale: 1,
    rotation: new Euler(0, 0, 0),
  },
}

export const upLgPositionAndScale: IPositionAndScale = {
  tabletHorizontal: {
    position: new Vector3(1, 0.8, 0),
    scale: 3,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  tabletVertical: {
    position: new Vector3(1, 1, 0),
    scale: 2.6,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  mobileHorizontal: {
    position: new Vector3(0.8, 1, 0),
    scale: 3,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  mobileVertical: {
    position: new Vector3(0.5, 0.9, 0),
    scale: 2.5,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  laptop: {
    position: new Vector3(0.4, 1, 0),
    scale: 2.5,
    rotation: new Euler(0, -0.4, 0),
  },
}

export const upMdPositionAndScale: IPositionAndScale = {
  tabletHorizontal: {
    position: new Vector3(1, 1, 0),
    scale: 3,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  tabletVertical: {
    position: new Vector3(1, 0.8, 0),
    scale: 2.5,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  mobileHorizontal: {
    position: new Vector3(1, 1.3, 0),
    scale: 2.8,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  mobileVertical: {
    position: new Vector3(0.4, 0.8, 0),
    scale: 2.5,
    rotation: new Euler(-0.1, -0.3, 0),
  },
  laptop: {
    position: new Vector3(0.5, 1, 0),
    scale: 2.5,
    rotation: new Euler(0, -0.3, 0),
  },
}

export const upSmPositionAndScale: IPositionAndScale = {
  tabletHorizontal: {
    position: new Vector3(0, 0, 0),
    scale: 4,
    rotation: new Euler(0, 0, 0),
  },
  tabletVertical: {
    position: new Vector3(0, -0.3, 0),
    scale: 3.5,
    rotation: new Euler(0, 0, 0),
  },
  mobileHorizontal: {
    position: new Vector3(0, 0, 0),
    scale: 4,
    rotation: new Euler(0, 0, 0),
  },
  mobileVertical: {
    position: new Vector3(0, -0.5, 0),
    scale: 3,
    rotation: new Euler(0, 0, 0),
  },
  laptop: {
    position: new Vector3(0, 0.5, 0),
    scale: 2.8,
    rotation: new Euler(0, 0, 0),
  },
}

export const xsPositionAndScale: IPositionAndScale = {
  tabletHorizontal: {
    position: new Vector3(0, 0, 0),
    scale: 3.5,
    rotation: new Euler(0, 0, 0),
  },
  tabletVertical: {
    position: new Vector3(0, -0.2, 0),
    scale: 3.5,
    rotation: new Euler(0, 0, 0),
  },
  mobileHorizontal: {
    position: new Vector3(0, 0, 0),
    scale: 3.2,
    rotation: new Euler(0, 0, 0),
  },
  mobileVertical: {
    position: new Vector3(0, -0.3, 0),
    scale: 3.2,
    rotation: new Euler(0, 0, 0),
  },
  laptop: {
    position: new Vector3(0, 0, 0),
    scale: 2.3,
    rotation: new Euler(0, 0, 0),
  },
}
